import { render, staticRenderFns } from "./PosCashManagement.vue?vue&type=template&id=687b8f3f&scoped=true"
import script from "./PosCashManagement.vue?vue&type=script&lang=js"
export * from "./PosCashManagement.vue?vue&type=script&lang=js"
import style0 from "./PosCashManagement.vue?vue&type=style&index=0&id=687b8f3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b8f3f",
  null
  
)

export default component.exports